/* eslint-disable @typescript-eslint/ban-types */
// react-table depends on spreading props; we could name them explicitly but this component might
// break if the shape of the return value from row.getRowProps() changes
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Cell, ColumnInstance, Row } from 'react-table';

import { defaultCellWidth } from '@trqk/components/src/table/constants';
import { IconCaret2 } from '@trqk/components';

import { COLUMN_IDS, EXTRA_CELL_WIDTH, caretIconWidth } from '../../constants';

interface Props {
    cell: Cell<TrqkGapChannelAudio>;
    column: ColumnInstance<TrqkGapChannelAudio>;
    row: Row<TrqkGapChannelAudio>;
}

export function GroupedChannelNameCell({
    cell,
    column,
    row,
}: Props): JSX.Element {
    const colWidth =
        typeof column.width === 'number' ? column.width : defaultCellWidth;
    // See notes in ../constants about this extra width
    const width = colWidth + EXTRA_CELL_WIDTH[COLUMN_IDS.CHANNEL_NAME];
    const { style: expandedRowStyle, ...restOfExpandedRowProps } =
        row.getToggleRowExpandedProps();

    return (
        <div
            className="grid items-center justify-items-start"
            style={{
                ...expandedRowStyle,
                width,
                gridTemplateColumns: `${caretIconWidth + 8}px auto`,
            }}
            {...restOfExpandedRowProps}
        >
            <IconCaret2
                addClasses="mr-1 mb-1"
                width={caretIconWidth}
                rotation={row.isExpanded ? 0 : 270}
            />{' '}
            <div className="flex items-center">
                <div
                    className="leading-tight clamp-1-lines-break-words"
                    style={{
                        width,
                    }}
                >
                    {cell.value}
                </div>
            </div>
        </div>
    );
}
